require('slick-carousel');

export default (slideUp, slideDown) => {
    const accordion = $('.js-media-accordion');
    const accordions = document.querySelectorAll('[data-accordion]');
    for (const accordion of accordions) {
        const titles = accordion.querySelectorAll('[data-accordion-title]');
        for (const title of titles) {
            title.addEventListener('click', (e) => {
                e.preventDefault();
                const item = title.parentNode;
                const content = item.querySelector('[data-accordion-content]');
                if (item.classList.contains('active')) { // close this
                    slideUp(content, {
                        duration: 150
                    });
                    item.classList.remove('active');
                } else {
                    $(".slick-slider").slick("refresh");
                    const activeSlides = accordion.querySelectorAll('.active[data-accordion-item]');
                    for (const activeSlide of activeSlides) {
                        const activeContent = activeSlide.querySelector('[data-accordion-content]');
                        activeSlide.classList.remove('active');
                        slideUp(activeContent, {
                            duration: 150
                        })
                    }
                    slideDown(content, {
                        duration: 150
                    });
                    item.classList.add('active');
                }
                return false;
            });
        }
    }

    setTimeout(function() {
        accordion.addClass('is-load');
    }, 300);
}

/*
import $ from 'jquery';
require('slick-carousel');

export default function () {

    var accordion = $('.js-media-accordion');
    var toggle = $('.js-accordion-title');
    var accordionContent = $('.js-accordion-content');
    var accordionItem = $('.js-accordion-item');

    toggle.on('click', function() {
        var $this = $(this);
        $(".slick-slider").slick("refresh");
        $this.closest(accordionItem).toggleClass('is-active');
        $this.closest(accordionItem).find(accordionContent).slideToggle('fast');
    });

    setTimeout(function() {
        accordion.addClass('is-load');
    }, 300);

}
*/
